import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { DELETE_URL } from '@utils/api/endpoints.ts';

type SuspendPayload = {
  suspended: boolean;
};

export const useSuspendCustomerBoSubscription = (
  customerId: number,
  subscriptionId: number
) => {
  const queryClient = useQueryClient();

  const suspendCustomerSubscription = async (payload: SuspendPayload) => {
    await Axios.patch(
      `${DELETE_URL(customerId.toString(), subscriptionId.toString()).suspendCustomerSubscription}`,
      payload
    );
  };

  return useMutation<void, AxiosError<BaseError>, SuspendPayload>(
    suspendCustomerSubscription,
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['customerSubscriptions', customerId]);
      },
      useErrorBoundary: false
    }
  );
};
